import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

// name of a value: one size on every card
export const labelSx = {
	fontSize: "0.95rem",
	color: "text.secondary",
} as const;

// Count pill next to a card title.
export const Count = ({
	children,
	gray,
}: {
	children: ReactNode;
	gray?: boolean;
}) => (
	<Box
		component="span"
		sx={{
			display: "inline-flex",
			alignItems: "center",
			height: 26,
			px: 1.25,
			borderRadius: 13,
			border: 1,
			borderColor: gray ? "#bdbdbd" : "primary.main",
			color: gray ? "text.primary" : "primary.main",
			fontSize: "0.85rem",
			fontWeight: 700,
		}}
	>
		{children}
	</Box>
);

export const Card = ({
	title,
	sub,
	badge,
	action,
	children,
}: {
	title: string;
	sub?: string;
	badge?: ReactNode;
	action?: ReactNode;
	children: ReactNode;
}) => (
	<Paper
		component="section"
		sx={{
			borderRadius: 2,
			display: "flex",
			flexDirection: "column",
			minHeight: 0,
			minWidth: 0,
		}}
	>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 1,
				minHeight: 48,
				borderBottom: "1px solid #eee",
				flexShrink: 0,
			}}
		>
			<Typography component="h2" sx={{ fontSize: "1rem", fontWeight: 500 }}>
				{title}
			</Typography>
			{sub && (
				<Typography variant="caption" color="text.secondary">
					{sub}
				</Typography>
			)}
			{badge}
			<Box sx={{ flexGrow: 1 }} />
			{action}
		</Box>
		{children}
	</Paper>
);
